import { useState, useEffect, useCallback } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import { FaListOl, FaDollarSign, FaArrowUp, FaArrowDown, FaEquals, FaGripLinesVertical, FaCheck } from 'react-icons/fa';

import { formatDateBucket, generateDateBuckets, getAutoResolution } from '../../../common/utils';
import TableMetric from '../../../containers/Reports/metric';
// import DoughnutCard from '../../Charts/Doughnut/card';
import BirthdayBar from '../../Charts/Bar/birthday';
import { getDateRange } from '../applyFilters';


export default function Birthdays( { data, filters } ) {
    const [ total, setTotal ] = useState( 0 );
    const [ closed, setClosed ] = useState( 0 );
    const [ referred, setReferred ] = useState( 0 );
    const [ metrics, setMetrics ] = useState( [
        { label: 'Total', value: 0, tooltip: '# of Contacts w/ a Bday', icon: <FaListOl style={{ color: '#ff7a59', marginRight: 8 }} /> },
        { label: 'Referred', value: 0, tooltip: '# of Contacts that sent a referral', icon: <FaDollarSign style={{ color: '#ff7a59', marginRight: 8 }} /> },
        { label: 'Closed', value: 0, tooltip: '# of Contacts that closed a loan', icon: <FaArrowUp style={{ color: '#ff7a59', marginRight: 8 }} /> },
        // { label: 'Lowest', value: 0, tooltip: 'Smallest Single Funded Loan', icon: <FaArrowDown style={{ color: '#ff7a59', marginRight: 8 }} /> },
        // { label: 'Average', value: 0, tooltip: 'Average Amount of Funded Loans', icon: <FaEquals style={{ color: '#ff7a59', marginRight: 8 }} /> },
        // { label: 'Median', value: 0, tooltip: 'Median Amount of Funded Loans', icon: <FaGripLinesVertical style={{ color: '#ff7a59', marginRight: 8 }} /> },
    ] );
    const [ rank, setRank ] = useState( [] );
    const [ summaryData, setSummaryData ] = useState( {
        total: 0,
        referred: 0,
        closed: 0,
        rank: {},
    } );
    const [ trendData, setTrendData ] = useState( [] );
    const [ resolution, setResolution ] = useState( 'monthly' );
    
    const getSummaryData = useCallback( () => {
        // const [startDate, endDate] = getDateRange(filters);
        // console.log( 'getSummaryData:', filters, startDate, endDate );
        const summary = {
            total: 0,
            referred: 0,
            closed: 0,
            rank: {},
        };
      
        const trendMap = {}; // { '2025-07': { units: 0, volume: 0 } }
        const allBuckets = generateDateBuckets( filters, resolution );
        for ( const bucket of allBuckets ) {
            trendMap[bucket] = { x: bucket, total: 0 };
        }
        console.log( 'trendMap:', trendMap );
      
        for ( const contact of data ) {
            const bday = new Date( contact.birthday?.match( 'T' ) ? contact.birthday : `${contact.birthday}T12:00:00` );
            if ( isNaN( bday ) ) continue;
        
            summary.total += 1;
        
            if ( contact.referred === true ) {
                summary.referred += 1;
            }

            if ( contact.closed === true ) {
                summary.closed += 1;
            }
            
            // Cancelled Reason
            const rank = contact.rank || contact.partnerRank || 'Unknown';
            if (!summary.rank[rank]) {
                summary.rank[rank] = { total: 0 };
            }
            summary.rank[rank].total += 1;
            
            // Trend (grouped by month/week/day)
            const bucket = formatDateBucket( bday, resolution, true );
            console.log( contact.name, contact.birthday, resolution, bucket );
            // console.log( bucket, contact );
            trendMap[bucket].total += 1;
        }

        const trendData = Object.values( trendMap ).sort( ( a, b ) => new Date( a.x ) - new Date( b.x ) );
      
        return {
            summaryData: summary,
            trendData,
        };
    }, [ data, resolution, filters ] );

    useEffect( () => {
        if ( data?.length ) {
            const summary = getSummaryData( 'weekly' );
            setSummaryData( summary.summaryData );
            setTrendData( summary.trendData );

            setTotal( summary.summaryData.total );
            setClosed( summary.summaryData.closed );
            setReferred( summary.summaryData.referred );
            
            console.log( 'summary:', summary );
        } else {
            setSummaryData( {
                total: 0,
                closed: 0,
                referred: 0,
                rank: {},
            } );
            setTrendData( [] );
            setTotal( 0 );
            setClosed( 0 );
            setReferred( 0 );
        }
    }, [ data, getSummaryData ] );

    useEffect( () => {
        setMetrics( [
            { label: 'Total', value: total, tooltip: '# of Contacts w/ a Bday', icon: <FaListOl style={{ color: '#ff7a59', marginRight: 8 }} /> },
            { label: 'Referred', value: referred, tooltip: '# of Contacts that sent a referral', icon: <FaDollarSign style={{ color: '#ff7a59', marginRight: 8 }} /> },
            { label: 'Closed', value: closed, tooltip: '# of Contacts that closed a loan', icon: <FaArrowUp style={{ color: '#ff7a59', marginRight: 8 }} /> },
            // { label: 'Lowest', value: 0, tooltip: 'Smallest Single Funded Loan', icon: <FaArrowDown style={{ color: '#ff7a59', marginRight: 8 }} /> },
            // { label: 'Average', value: 0, tooltip: 'Average Amount of Funded Loans', icon: <FaEquals style={{ color: '#ff7a59', marginRight: 8 }} /> },
            // { label: 'Median', value: 0, tooltip: 'Median Amount of Funded Loans', icon: <FaGripLinesVertical style={{ color: '#ff7a59', marginRight: 8 }} /> },
        ] );
    }, [ total, closed, referred ] );

    useEffect( () => {
        const rank = Object.keys( summaryData.rank || {} );
        const list = [];

        if ( rank.length ) {
            rank.forEach( r => {
                list.push( {
                    label: r,
                    value: summaryData.rank[r].total,
                    tooltip: `# of Contacts Ranked as: ${r}`,
                    icon: <FaCheck style={{ color: '#ff7a59', marginRight: 8 }} />
                } );
            } )
        } else {
            list.push( {
                label: 'N/A',
                value: 0,
                tooltip: `No Ranked Contacts`,
                icon: <FaCheck style={{ color: '#ff7a59', marginRight: 8 }} />
            } );
        }

        setRank( list.sort( ( a, b ) => a.label.localeCompare( b.label ) ) );
    }, [ summaryData.rank ] );

    useEffect( () => {
        if ( filters ) {
            setResolution( getAutoResolution( filters ) )
        }
    }, [ filters ] );


    return (
        <Container fluid className='w-100'>
            <Row className='pb-4 text-center'>
                <Col className='ps-0' sm={2}>
                    <Box className='h-100' display="flex" gap={2} justifyContent="space-evenly" sx={ { flexDirection: { xs: 'column', md: 'row' } } }>
                        <Card variant="outlined" className='py-1 px-0 me-2 w-100' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Row className="d-flex justify-content-between align-items-center mb-2" style={ { padding: 'var( --bs-card-spacer-y ) var( --bs-card-spacer-x )' } }>
                                <Col>
                                    <Card.Title as="h6" className="mb-0">Metrics</Card.Title>
                                </Col>
                            </Row>
                            <Stack 
                                direction="column" 
                                justifyContent="space-evenly" 
                                spacing={0} 
                                sx={{ width: 1, flex: 1, minHeight: 0 }} 
                                divider={ <Divider orientation="horizontal" flexItem style={ { backgroundColor: 'grey' } } /> }
                            >
                            {
                                metrics.map( ( metric, idx ) => (
                                    <TableMetric key={`metric-${idx}`} metric={metric} idx={idx} showDivider={ idx < ( metrics.length - 1 ) } direction='vertical' />
                                ) )
                            }
                            </Stack>
                        </Card>
                    </Box>
                </Col>
                <Col className='ps-0' sm={2}>
                    <Box className='h-100' display="flex" gap={2} justifyContent="space-evenly" sx={ { flexDirection: { xs: 'column', md: 'row' } } }>
                        <Card variant="outlined" className='py-1 px-0 me-2 w-100' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Row className="d-flex justify-content-between align-items-center mb-2" style={ { padding: 'var( --bs-card-spacer-y ) var( --bs-card-spacer-x )' } }>
                                <Col>
                                    <Card.Title as="h6" className="mb-0">Rankings</Card.Title>
                                </Col>
                            </Row>
                            <Stack 
                                direction="column" 
                                justifyContent="space-evenly" 
                                spacing={0} 
                                sx={{ width: 1, flex: 1, minHeight: 0 }} 
                                divider={ <Divider orientation="horizontal" flexItem style={ { backgroundColor: 'grey' } } /> }
                            >
                            {
                                rank.map( ( metric, idx ) => (
                                    <TableMetric key={`rank-${idx}`} metric={metric} idx={idx} showDivider={ idx < ( rank.length - 1 ) } direction='vertical' />
                                ) )
                            }
                            </Stack>
                        </Card>
                    </Box>
                </Col>
                <Col className='px-0'>
                    <Card className="h-100">
                        <Card.Body>
                            <Row className="d-flex justify-content-between align-items-center mb-2">
                                <Col>
                                    <Card.Title as="h6" className="mb-0">Birthday Distributions</Card.Title>
                                </Col>
                            </Row>
                            <Row>
                                <Col style={ { height: '400px' } }>
                                    <BirthdayBar data={trendData} height={400} />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className='pb-4'>
                
            </Row>
        </Container>
    );
}